import { AnyAction } from "redux";

import { ACTION_PENDING } from "@services/AsyncActionCreatorFactory";

/**
 * @returns `{type: ACTION_NAME + ACTION_PENDING}`
 */
const genericPendingAction = (
  ACTION_NAME: string,
  params?: { [key: string]: any },
): AnyAction => ({
  type: `${ACTION_NAME}${ACTION_PENDING}`,
  params,
});

export { genericPendingAction };
